import { captureException } from './.client/sentry';

export async function sendSentryError(originalError: unknown) {
  try {
    const error = originalError instanceof Error ? originalError : new Error(`${originalError}`);

    if (import.meta.env.DEV) {
      return;
    }

    captureException(error);
  } catch {
    // let's not crash the app for now
  }
}
